import React from 'react'
import { Card, CardContent, Grid, Typography, Box, makeStyles } from '@material-ui/core'
import DropzoneComponent from 'react-dropzone-component'
import 'dropzone/dist/min/dropzone.min.css'
import 'react-dropzone-component/styles/filepicker.css'
import { Trans } from 'react-i18next'
import { useAlert } from '../reducer'
import { useAuth, useFetch } from '../context/useFetch'
import { API_HOST } from '../../src/constants'
import i18n from '../i18n/i18n'

const useStyles = makeStyles((theme) => ({
  dropzone: {
    '&.filepicker': {
      fontFamily: 'inherit',
      border: 'none',
      borderRadius: '16px',
      padding: theme.spacing(6),
      backgroundImage: `url("data:image/svg+xml,%3csvg width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%' height='100%' fill='none' rx='16' ry='16' stroke='%231985A1' stroke-width='5' stroke-dasharray='32 8 8' stroke-dashoffset='0' stroke-linecap='butt'/%3e%3c/svg%3e")`,
    },
    '&::before': {
      backgroundImage: 'url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxZW0iIGhlaWdodD0iMWVtIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGZpbGw9IiMxOTg1QTEiIGQ9Ik0xMSAyMEg2LjVxLTIuMjc1IDAtMy44ODctMS41NzVRMSAxNi44NSAxIDE0LjU3NXEwLTEuOTUgMS4xNzUtMy40NzVRMy4zNSA5LjU3NSA1LjI1IDkuMTVxLjYyNS0yLjMgMi41LTMuNzI1UTkuNjI1IDQgMTIgNHEyLjkyNSAwIDQuOTYyIDIuMDM3UTE5IDguMDc1IDE5IDExcTEuNzI1LjIgMi44NjMgMS40ODdRMjMgMTMuNzc1IDIzIDE1LjVxMCAxLjg3NS0xLjMxMiAzLjE4OFEyMC4zNzUgMjAgMTguNSAyMEgxM3YtNy4xNWwxLjYgMS41NUwxNiAxM2wtNC00bC00IDRsMS40IDEuNGwxLjYtMS41NVoiLz48L3N2Zz4=")'
    },
    '& .dz-message': {
      margin: theme.spacing(0)
    }
  }
}))

export const SubscribeMe = ({ condition, h1, subTitle, subText, url = 'documents', successHandler }) =>
  useFetch(
    ({ fetch }) => ({
      docTypes: fetch('/document_types')
    }),
    ({ docTypes }) => {
      const alert = useAlert()
      const classes = useStyles()

      const cvDocumentType = docTypes.find((document) => document.slug === 'cv')

      const successUpload =
        successHandler ||
        (async () => {
          alert('notice', <Trans i18nKey="alerts.saved_data" />)
        })

      const failureHandler = () => {
        alert('error', <Trans i18nKey="alerts.saved_error" />)
      }

      const auth = useAuth()

      if (condition && condition(auth)) {
        return null
      }

      return (
        <Card elevation={0} style={{ backgroundColor: 'rgba(25, 133, 161, 0.1)' }}>
          <CardContent className="geCard bigCard">
            <Typography component="h2" variant="h3">
              {h1}
            </Typography>

            <Grid container alignItems="center" spacing={4}>
              <Grid item xs={12} md={6}>
                <Typography component="h3" variant="h1" style={{ marginBottom: '8px' }}>
                  {subTitle}
                </Typography>
                <Typography>
                  {subText}
                </Typography>
              </Grid>

              <Grid item xs={12} md={6}>
                <DropzoneComponent
                  className={classes.dropzone}
                  config={{
                    postUrl: `//${API_HOST()}/api/${url}`
                  }}
                  djsConfig={{
                    maxFiles: 10,
                    dictDefaultMessage: i18n.t('registration.candidat.step0.dropzone_text'),
                    acceptedFiles: 'application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    paramName: 'document[file]',
                    params: { 'document[document_type_id]': cvDocumentType.id },
                    uploadMultiple: true,
                    parallelUploads: 1,
                    headers: auth.loggedIn() ? auth.authHeaders() : {}
                  }}
                  eventHandlers={{
                    successmultiple: successUpload,
                    successMultiple: successUpload,
                    failure: failureHandler
                  }}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      )
    }
  )
